import styled from 'styled-components';

export const MenuContainer = styled.div`
  display: inline-block;
  flex-shrink: 0;
`;

export const ItemsList = styled.ul`
  display: block;
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const Item = styled.li`
  display: inline-block;
  box-sizing: border-box;
  font-weight: 600;
  color: ${props => props.theme.colors.neutral['700']};
  border-radius: ${props => (props.underlined ? '0' : '4px')};

  & + & {
    margin-left: ${props => (props.underlined ? '16px' : '0')};
  }

  ${props =>
    props.isActive &&
    (props.underlined
      ? `border-bottom: 2px solid ${props.theme.colors.primary['500']};`
      : `
      color: ${props.theme.colors.primary['700']};
      background: ${props.theme.colors.primary['100']};
  `)}
`;

export const ItemContent = styled.div`
  padding: ${props => (props.underlined ? '4px' : '8px 16px')};
  ${props => (props.role === 'button' ? 'cursor: pointer' : '')}
`;
